import React, { useState, useEffect } from 'react';
import "./SearchFilter.css";

export const SearchFilterDesc = ({ onSearchFilter, categories }) => {
  const [name, setName] = useState('');
  const [category, setCategory] = useState('');

  const handleSearch = () => {
    onSearchFilter({ name, category });
  };

  return (
    <div className="search-filter">
      <label>
        名称：
        <input type="text" placeholder="请输入名称" value={name} onChange={(e) => setName(e.target.value)} />
      </label>
      <label>
        类别:
        <select value={category} onChange={(e) => setCategory(e.target.value)}>
        <option value="">全部</option>
        {categories.map((cat, index) => (
          <option key={index} value={cat}>{cat}</option>
        ))}
      </select>
      </label>
      <button onClick={handleSearch}>查询</button>
    </div>
  );
};


const SearchFilterClass = ({ onSearchFilter, instructors, studios, classDates }) => {
  const [name, setName] = useState('');
  const [classDate, setClassDate] = useState('');
  const [studio, setStudio] = useState('');
  const [instructor, setInstructor] = useState('');
  const [sortedClassDates, setSortedClassDates] = useState([]);

  useEffect(() => {
    const sortedDates = [...(classDates || [])].sort((a, b) => new Date(a) - new Date(b));
    setSortedClassDates(sortedDates);
  }, [classDates]);

  const handleSearch = () => {
    onSearchFilter({ name, class_date: classDate, studio, instructor });
  };

  return (
    <div className="search-filter-grid">
      <div className="filter-item">
        <span className="filter-label">名称：</span>
        <input
          type="text"
          value={name}
          placeholder="请输入名称"
          onChange={(e) => setName(e.target.value)}
        />
      </div>

      <div className="filter-item">
        <span className="filter-label">门店：</span>
        <select value={studio} onChange={(e) => setStudio(e.target.value)}>
          <option value="">请选择门店</option>
          {(studios || []).filter(Boolean).map((sd, idx) => (
            <option key={idx} value={sd}>{sd}</option>
          ))}
        </select>
      </div>

      <div className="filter-item">
        <span className="filter-label">日期：</span>
        <select value={classDate} onChange={(e) => setClassDate(e.target.value)}>
          <option value="">请选择日期</option>
          {(sortedClassDates || []).filter(Boolean).map((d, i) => (
            <option key={i} value={d}>{d}</option>
          ))}
        </select>
      </div>

      <div className="filter-item">
        <span className="filter-label">教练：</span>
        <select value={instructor} onChange={(e) => setInstructor(e.target.value)}>
          <option value="">请选择教练</option>
          {(instructors || []).filter(Boolean).map((name, i) => (
            <option key={i} value={name}>{name}</option>
          ))}
        </select>
      </div>

      <div className="filter-item filter-button">
        <button onClick={handleSearch}>查询</button>
      </div>
    </div>
  );
};

export default SearchFilterClass;


